<template>
  <component
    :is="component.name"
    v-if="methodType"
    v-bind="component.props"
    v-on="component.events"
  />
</template>



<script>
  import TipSelectionButton from './tip-selection-button.vue';
  import TipSelectionDefault from './tip-selection-default.vue';
  import { mapGetters } from 'vuex';



  export default {
    name: 'TipSelection',

    components: {
      TipSelectionButton,
      TipSelectionDefault
    },

    inject: {
      $validator: {
        from: '$validator'
      },

      validatedForm: {
        from: 'validatedForm',
        default() {
          return {};
        }
      }
    },

    props: {
      customRadioStyle: {
        type: String,
        default: null
      },

      label: {
        type: String,
        default: 'Would you like to add a tip?'
      },

      showButtonLabel: {
        type: Boolean,
        default: false
      },

      showAsOptional: {
        type: Boolean,
        default: false
      },

      total: {
        type: Number,
        required: true
      },

      modelValue: {
        type: Number,
        default: 0
      }
    },

    computed: {
      ...mapGetters('hotels', ['selectedDepartment']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('orders', ['currentCapiOrderType']),

      options() {
        const groupOptionsByType = tippingOptions => tippingOptions.reduce((obj, tippingOption) => {
          const { tippingOptionType } = tippingOption;

          if (!(tippingOptionType in obj)) {
            obj[tippingOptionType] = [];
          }
          obj[tippingOptionType].push(tippingOption);

          return obj;
        }, {});

        const optionsByOrderType = {
          ...groupOptionsByType(this.merchant.options.tippingOptions),
          ...this.selectedLocation && groupOptionsByType(this.selectedLocation.tippingOptions),
          ...this.selectedDepartment && groupOptionsByType(this.selectedDepartment.tippingOptions)
        };

        return optionsByOrderType[this.currentCapiOrderType] || optionsByOrderType.Default || [];
      },

      component() {
        const props = {
          options: this.options,
          showAsOptional: this.showAsOptional,
          total: this.total,
          value: this.modelValue
        };

        const events = { select: this.tipSelectHandler };

        switch (this.methodType) {
          case 'Button':
            return {
              name: 'TipSelectionButton',
              props: {
                ...props,
                ...this.showButtonLabel && { label: this.label }
              },
              events
            };

          default:
            return {
              name: 'TipSelectionDefault',
              props: {
                ...props,
                label: this.label,
                customRadioStyle: this.customRadioStyle
              },
              events
            };
        }
      },

      methodType() {
        const hasTippingEnabled = this.selectedLocation.features.TippingEnabled ?? this.merchant.options.patTipping;

        return hasTippingEnabled && this.options.length
          ? this.options[0].tippingMethodType
          : null;
      }
    },

    methods: {
      tipSelectHandler(value) {
        this.$emit('update:modelValue', value || 0);
      }
    }
  };
</script>
